<template>
  <div class="px-4 py-4">
    <h3>How are the dose response curves fitted? What are the parameters for fitting?</h3>
    <DrcDetails></DrcDetails>
  </div>
</template>

<script>
//  import * as d3 from 'd3';
import DrcDetails from '@/dynamic-content/DrcDetails.vue';

export default {
  name: 'dose-response-drawer',
  components: {DrcDetails},
  data: () => ({

  }),
  mounted() {

  },
  methods: {},
  watch: {}
}
</script>

<style scoped>


</style>
